module.exports = __webpack_public_path__ + "media/images/client/favicons/apple-touch-icon-60x60-073065fd6c01ac9de00c22e8c1a8beae.png";